export default __webpack_public_path__ + "static/media/en_shareplug.b2b5ad89.mp4";